import ServiceCRUD from '../../../../services/ServiceGasOrder';

class ServiceXlsx extends ServiceCRUD {
  constructor() {
    super('api/exportar-oportunidades-xlsx');
  }
}

export default new ServiceXlsx();
